
import * as defaultImport from "nearley";
export * from "nearley";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
